/**
 * 定义过滤器集
 * 类比于getter(处理state)
 * (c) 2017 进门web团队
 * **/

import Vue from 'vue';
import {
	dateFormat,
	dateFormatMonthDateTime,
	dateFormatMonthDateTimeSP,
	dateFormatYearMonthDate,
	dateFormatYearMonthDateTime,
	dateFormatMonthDateWithNumber,
	dateFormatMonthDateWithWeek,
	dateFormatYearMonth,
	dateFormatMonthDate,
	dateFormatDay,
	getMathRound,
	dateFormatBetweenThisYearOrPreviousYears,
	formatDefault,
	dateFormatTime
} from './api';
import * as objEnum from '@/utils/enum';
// 自定义缩略图
// @w : 缩略图宽
// @h : 缩略图高
Vue.filter('thumbnail', (str, w, h) => {
	if (str) return str + '!' + w + '_' + h;
});

// 反转
Vue.filter('reverse', val => val.split('').reverse().join(''));

// 字符相关
// 清除字符前后空格
Vue.filter('clearSpace', str => str.replace(/(^\s*)|(\s*)$/g, ''));

// 替换文本中 所以换行(\n)为<br/>
Vue.filter('replaceAllLineBreakWithBr', str => {
	const reg = new RegExp(/\\+n/g);
	return reg.test(str) ? str.replace(reg, '<br/>') : str;
});

// 去除字符中的 <br/> 标签
Vue.filter('removeBr', str => {
	const reg = new RegExp(/<br\s*\\?\/?>/gi);
	return reg.test(str) ? str.replace(reg, '') : str;
});

// 去除文档中超链接
Vue.filter('removeAllHyperLink', html => {
	const reg = new RegExp(/<a[^>]*href=['"]([^"]*)['"].*?[^>]*>(.*?)<\/a>/gi);
	return reg.test(html) ? html.replace(reg, '') : html;
});

// 替换所有超链接为文本
Vue.filter('replaceAllHyperLinkToText', html => {
	const reg = new RegExp(/<a[^>]*href=['"]([^"]*)['"].*?[^>]*>(.*?)<\/a>/gi);
	const regAnchoStart = new RegExp(/<a[^>]*href=['"]([^"]*)['"].*?[^>]*>/gi);
	const regAnchoEnd = new RegExp(/<\/a>/gi);
	return reg.test(html) ? html.replace(regAnchoStart, '').replace(regAnchoEnd, '') : html;
});

// 数字相关
// 求一组数（数组）的评价数
// digit : 位数，默认两位
Vue.filter('getAvg', (arr = [0], digit = 2) => {
	let sum = 0;
	let len = arr.length;

	for (let i = 0; i < len; i++) {
		sum += Number(arr[i]);
	}

	return (sum / len).toFixed(digit);
});

// 过滤商品价格，以分为单位，保留两位小数
// symbol：需要展示的符号，默认 ¥，如果不需要显示，给 false(boolean)
Vue.filter('computedGoodsPrice', (p, symbol) => {
	return p ? (symbol === false ? '' : symbol || '¥') + (p / 100).toFixed(2) : '0.00';
});

// 四舍五入
Vue.filter('getMathRound', (number = 0, digit = 2) => {
	const exponent = Math.pow(10, digit);
	return Math.round(number * exponent) / exponent;
});

// 过滤超过1万时，显示以万为单位
Vue.filter('computedNumMoreThanTenThousand', (number = 0, digit = 1) => {
	return number >= Math.pow(10, 4) ? (number / Math.pow(10, 4)).toFixed(digit) + '万' : number;
});

// 计算成交额
Vue.filter('computedTradeAmount', val => {
	return val
		? getMathRound(val / (100 * 1000 * 1000), 1) > 0.1
			? getMathRound(val / (100 * 1000 * 1000), 2) + '亿'
			: getMathRound((val / (100 * 1000 * 1000)) * 10 * 1000, 0) + '万'
		: '- -';
});

// 计算总市值
Vue.filter('computedAllValue', val => {
	return val
		? getMathRound(val, 1) > 0.1
			? getMathRound(val, 2) + '亿'
			: getMathRound(val * 10 * 1000, 0) + '万'
		: '- -';
});

// 计算市盈率
Vue.filter('computedPe', val => {
	return val ? getMathRound(val, 2) : '- -';
});

// 计算换手率
Vue.filter('computedTurnOver', val => {
	return val ? getMathRound(val, 2) + '%' : '- -';
});

// 计算股票上涨下降比例
Vue.filter('stockPrice', (number = 0) => {
	// let num = (number < 0) ? number.substring(1) : number;
	return getMathRound(number, 2) + '%';
});

Vue.filter('mediaTimeFormat', time => {
	// time 单位为秒
	// 取整
	time = parseInt(time);
	const m = parseInt(time / 60);
	const h = parseInt(time / 3600);
	// 取秒
	let second = parseInt(time % 60);
	second = second < 10 ? '0' + second : second;
	// 取分
	let min = parseInt(m % 60);
	min = min < 10 ? '0' + min : min;
	// 取小时
	const hour = h < 10 ? '0' + h : h;
	return (h > 0 ? hour + ':' : '') + min + ':' + second;
});

// 时间格式化
Vue.filter('dateFormat', (date, fmt) => {
	const o = {
		'M+': date.getMonth() + 1, //月份
		'd+': date.getDate(), //日
		'h+': date.getHours() % 24 === 0 ? '00' : date.getHours() % 24,
		'H+': date.getHours(), //小时
		'm+': date.getMinutes(), //分
		's+': date.getSeconds(), //秒
		'q+': Math.floor((date.getMonth() + 3) / 3), //季度
		S: date.getMilliseconds() //毫秒
	};

	const week = {
		0: '/u65e5',
		1: '/u4e00',
		2: '/u4e8c',
		3: '/u4e09',
		4: '/u56db',
		5: '/u4e94',
		6: '/u516d'
	};

	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
	}
	if (/(E+)/.test(fmt)) {
		fmt = fmt.replace(
			RegExp.$1,
			(RegExp.$1.length > 1 ? (RegExp.$1.length > 2 ? '/u661f/u671f' : '/u5468') : '') + week[date.getDay() + '']
		);
	}

	for (var k in o) {
		if (new RegExp('(' + k + ')').test(fmt)) {
			fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
		}
	}

	return fmt;
});

/* 友好式的时间格式化：几分钟前，几小时前，隔天显示 月 日 时 分，隔年显示 年 月 日 */
Vue.filter('dateFormatFriendly', timestamp => {
	/* 获取当前时间戳
	 * 用当前时间和参数时间戳作对比
	 *  如果当前时间与参数时间戳差值(毫秒)
	 *  	小于 1 个小时。显示 几分钟前
	 *  	小于 1 天，显示 几小时前
	 *  	否则，年是否等于当年
	 *  		是显示 月 日 时 分
	 *  			否则 年 月 日
	 * */
	const now = new Date().getTime();
	const nowYear = new Date().getFullYear();
	const timestampYear = new Date(Number(timestamp)).getFullYear();
	const diffTimestamp = now - timestamp;
	if (diffTimestamp < 60 * 1000) {
		return '刚刚';
	} else if (diffTimestamp < 60 * 60 * 1000) {
		return Math.floor(diffTimestamp / (60 * 1000)) + '分钟前';
	} else if (diffTimestamp < 24 * 60 * 60 * 1000) {
		return Math.floor(diffTimestamp / (60 * 60 * 1000)) + '小时前';
	} else if (nowYear === timestampYear) {
		return dateFormatMonthDateTime(timestamp);
	} else {
		return dateFormatYearMonthDate(timestamp);
	}
});

//时间显示规范化(showToday是否显示今天时间变化)
Vue.filter('dateCalculate', (timeStr, showToday) => {
	//        timeStr 获取时间 timeNow 现在时间
	let timeNow = new Date().getTime(),
		timeCal = timeNow > timeStr ? timeNow - timeStr : timeStr - timeNow,
		timeNum = parseInt(timeCal / 1000);
	if (timeNum > 86400) {
		let yearStr = dateFormat(new Date(Number(timeStr)), 'yyyy');
		let yearNow = new Date().getFullYear();
		if (yearNow - yearStr < 1) {
			return dateFormatMonthDateTime(timeStr);
		} else {
			return dateFormatYearMonthDate(timeStr);
		}
	} else {
		if (showToday) {
			if (timeCal < 1000) {
				return '刚刚';
			} else {
				if (timeNum > 3600) {
					return parseInt(timeNum / (60 * 60)) + '小时前';
				} else if (timeNum > 60) {
					return parseInt(timeNum / 60) + '分钟前';
				}
			}
		} else {
			return dateFormatMonthDateTime(timeStr);
		}
	}
});

Vue.filter('dateFormatYearMonthDate', date => {
	return dateFormatYearMonthDate(date);
});

Vue.filter('dateFormatMonthDateTime', date => {
	return dateFormatMonthDateTime(date);
});

Vue.filter('dateFormatMonthDateTimeSP', date => {
	return dateFormatMonthDateTimeSP(date);
});

Vue.filter('dateFormatYearMonthDateTime', date => {
	return dateFormatYearMonthDateTime(date);
});

Vue.filter('dateFormatMonthDate', date => {
	return dateFormatMonthDate(date);
});

Vue.filter('dateFormatMonthDateWithNumber', date => {
	return dateFormatMonthDateWithNumber(date);
});

Vue.filter('dateFormatMonthDateWithWeek', date => {
	return dateFormatMonthDateWithWeek(date);
});

Vue.filter('dateFormatYearMonth', date => {
	return dateFormatYearMonth(date);
});

Vue.filter('dateFormatDay', date => {
	return dateFormatDay(date);
});

Vue.filter('dateFormatBetweenThisYearOrPreviousYears', date => {
	return dateFormatBetweenThisYearOrPreviousYears(date);
});
Vue.filter('dateFormatTime', date => {
	return dateFormatTime(date);
});

/** 通过返回的路演厅权限，自动返回专场标签
 *
 * @param isPublic {String} 路演权限 0:私密 1:公开 2:专场 3:私募 4:付费 5:开户分仓 6:实名认证 7:申请参会 8:调研活动
 * @returns {*} 返回专场标签
 */
Vue.filter('computedSpecialTag', isPublic => {
	switch (isPublic) {
		case '0':
			return '#私密';
		case '1':
			return '';
		case '4':
			return '#付费';
		default:
			return '#专场';
	}
});

/** 通过返回的路演状态数值，自动返回对应的路演状态
 *
 * @param status {String} 直播状态数值
 * @returns {*} 返回对应的直播状态名称
 */
Vue.filter('computedLiveStatus', status => {
	switch (Number(status)) {
		case 0:
			return '预告';
		case 1:
			return '直播';
		case 3:
			return '回放';
	}
});

/** 通过返回的路演类型，自动返回对应的路演类型
 *
 * @param types {String} 直播状态数值
 * @returns {*} 返回对应的直播状态名称
 */
Vue.filter('computedTopicType', types => {
	switch (types) {
		case '0':
			return '路演';
		case '1':
			return '回放';
		case '5':
			return '文章';
		case '6':
			return '股票';
	}
});

/** 通过返回的直播状态数值，自动返回对应的直播标签样式
 *
 * @param status {String} 直播状态数值
 * @param size {String} 标签尺寸
 * @returns {*} 返回直播样式
 */
Vue.filter('computedLiveStatusStyle', (status, size) => {
	switch (status) {
		case '0':
			return size === 'small'
				? 'm-label-predict-small'
				: size === 'normal'
					? 'm-label-predict-normal'
					: size === 'large'
						? 'm-label-predict-large'
						: 'm-label-predict-normal';
		case '1':
			return size === 'small'
				? 'm-label-live-small'
				: size === 'normal'
					? 'm-label-live-normal'
					: size === 'large'
						? 'm-label-live-large'
						: 'm-label-live-normal';
		case '3':
			return size === 'small'
				? 'm-label-playback-small'
				: size === 'normal'
					? 'm-label-playback-normal'
					: size === 'large'
						? 'm-label-playback-large'
						: 'm-label-playback-normal';
		default:
			break;
	}
});

Vue.filter('computedLiveStatusStyleNew', (status, size) => {
	switch (Number(status)) {
		case 0:
			return size === 'small'
				? 'm-label-predict-small-new'
				: size === 'normal'
					? 'm-label-predict-normal-new'
					: size === 'large'
						? 'm-label-predict-large-new'
						: 'm-label-predict-normal-new';
		case 1:
			return size === 'small'
				? 'm-label-live-small-new'
				: size === 'normal'
					? 'm-label-live-normal-new'
					: size === 'large'
						? 'm-label-live-large-new'
						: 'm-label-live-normal-new';
		case 3:
			return size === 'small'
				? 'm-label-playback-small-new'
				: size === 'normal'
					? 'm-label-playback-normal-new'
					: size === 'large'
						? 'm-label-playback-large-new'
						: 'm-label-playback-normal-new';
		default:
			break;
	}
});

Vue.filter('computedLiveStatusStylePlain', (status, size) => {
	switch (Number(status)) {
		case 0:
			return size === 'small'
				? 'm-label-predict-small-plain'
				: size === 'normal'
					? 'm-label-predict-normal-plain'
					: size === 'large'
						? 'm-label-predict-large-plain'
						: 'm-label-predict-normal-plain';
		case 1:
			return size === 'small'
				? 'm-label-live-small-plain'
				: size === 'normal'
					? 'm-label-live-normal-plain'
					: size === 'large'
						? 'm-label-live-large-plain'
						: 'm-label-live-normal-plain';
		case 3:
			return size === 'small'
				? 'm-label-playback-small-plain'
				: size === 'normal'
					? 'm-label-playback-normal-plain'
					: size === 'large'
						? 'm-label-playback-large-plain'
						: 'm-label-playback-normal-plain';
		default:
			break;
	}
});

/** 通过实名认证返回的状态值，自动返回对应的状态文字
 *
 * @param status {String} 实名认证状态
 * @returns {*} 返回文字
 */
Vue.filter('computedRealNameStatus', status => {
	switch (status) {
		case '0':
			return '认证中';
		case '1':
			return '已认证';
		case '2':
			return '未通过';
		case '3':
			return '认证';
		default:
			return '认证';
	}
});

/** 通过机构投资者返回的状态值，自动返回对应的状态文字
 *
 * @param status {String} 机构投资者
 * @returns {*} 返回文字
 * 0 ：未提交信息 1： 审核通过 2： 审核不通过 3 ： 审核中
 */
Vue.filter('computedInvestorReviewStatus', status => {
	switch (status) {
		case '1':
			return '已认证';
		case '3':
			return '认证中';
		default:
			return '认证';
	}
});

/**
 * 计算股票价格对应颜色 上涨、下跌、持平
 * **/
Vue.filter('computedStockColor', number => {
	if (number > 0) {
		return 'stock-increase';
	} else if (number < 0) {
		return 'stock-decrease';
	} else {
		return 'stock-flat';
	}
});

/**
 * 计算股票买入卖出对应的颜色
 */
Vue.filter('computedStockRateColor', number => {
	if (number === 0) {
		return 'stock-rate-green';
	} else if (number === 1 || number === 2) {
		return 'stock-rate-red';
	}
});

/**
 * 计算股票价格对应背景颜色 上涨、下跌、持平
 * **/
Vue.filter('computedStockBgColor', number => {
	if (number > 0) {
		return 'stock-increase-bg';
	} else if (number < 0) {
		return 'stock-decrease-bg';
	} else {
		return 'stock-flat-bg';
	}
});

/** 返回指数小数位数
 *
 * @param number {String} 指数数值
 * @param digit (String)  精确到几位小数
 * @returns {*}  返回精确到几位小数后的指数
 */
Vue.filter('computedStockDigit', (number, digit = 2) => {
	return number === undefined ? Number(0).toFixed(digit) : getMathRound(number, digit).toFixed(digit);
});

/** 计算股票增长率的符号(+、-、'') **/
Vue.filter('computedStockRateSymbol', number => {
	return number === undefined ? '0.00' : number > 0 ? '+' + number : number;
});

/** 返回VIP状态
 * @param status {String} vip状态码
 * @return {*} 返回状态
 * **/
Vue.filter('computedVipStatus', (status, time) => {
	switch (status) {
		case '0':
			return '开通';
		case '1':
			// v3.4.1需求：不再显示到期时间
			return '已开通';
		// return dateFormatYearMonthDate(time) + ' 到期';
		case '2':
			return '已过期';
		default:
			return '开通';
	}
});

// 空值显示默认横杆
Vue.filter('toDefault', value => {
	return formatDefault(value);
});

Vue.filter('enums', (value, key) => {
	let obj = objEnum[key];
	return obj ? obj[value] : '-';
});
